import { useEffect } from 'react';
import './LpPage.css';

const LpPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="lp-page">
      <iframe
        src="/lp/index.html"
        title="Chiriri Keiba LP"
        className="lp-iframe"
        loading="lazy"
      />
    </div>
  );
};

export default LpPage;
